<template>
<!-- inputs arriba = prod -->
<!-- inputs abajo = dev -->
    <div id="terminal_de_pago">
        <form @submit.prevent="sendForm()">
            <div class="form-title">
                <p><b>Terminal de pago</b></p>
            </div>
            <hr>
            <div class="form-2c-3c">
                <div>
                    <i id="amount_dollar" class="fas fa-dollar-sign"></i>
                    <input type="number" name="monto" placeholder="Monto" v-model="payData.amount" @change="changeMsi()" required min="1" pattern="^[0-9]+">
                    <!-- <input type="number" name="monto" placeholder="Monto" v-model="payData.amount" @change="changeMsi()" min="1" pattern="^[0-9]+"> -->
                </div>
                <input type="text" name="concept" placeholder="Concepto de pago" minlength="3" v-model="payData.paymentConcept" required>
                <!-- <input type="text" name="concept" placeholder="Concepto de pago" v-model="payData.paymentConcept" > -->
            </div>
            <div class="form-title">
                <h3>Datos del Usuario</h3>
            </div>
            <div class="form-3c">
                <input type="text" name="nameUser" placeholder="Nombre" v-model="payData.firstName" required>
                <!-- <input type="text" name="nameUser" placeholder="Nombre" v-model="payData.firstName" > -->
                <input type="text" name="lastName" placeholder="Apellido" v-model="payData.lastName" required>
                <!-- <input type="text" name="lastName" placeholder="Apellido" v-model="payData.lastName" > -->
                <input type="email" name="email" placeholder="Correo electrónico" v-model="payData.email" required>
                <!-- <input type="text" name="email" placeholder="Correo electrónico" v-model="payData.email"> -->
            </div>
            <div class="form-2c">
                <input type="text" name="address" placeholder="Dirección" autocomplete="on" minlength="2" v-model="payData.address" required>
                <!-- <input type="text" name="address" placeholder="Dirección" autocomplete="on" v-model="payData.address" > -->
                <input type="text" name="city" placeholder="Ciudad" autocomplete="on" v-model="payData.city" required>
                <!-- <input type="text" name="city" placeholder="Ciudad" autocomplete="on" v-model="payData.city" > -->
                <select id="country_select" @change="changeCountry()" required>
                    <option hidden selected>País</option>
                    <option v-for="country in countries" :key="country" :value="country">{{country}}</option>
                </select>
                <input type="text" name="province" placeholder="Estado / Provincia" autocomplete="on" v-model="payData.province" required>
                <!-- <input type="text" name="province" placeholder="Estado / Provincia" autocomplete="on" v-model="payData.province" > -->
                <input type="tel" name="cp" placeholder="Código postal" autocomplete="on" maxlength="5" v-model="payData.cp" required>
                <!-- <input type="tel" name="cp" placeholder="Código postal" autocomplete="on" maxlength="5" v-model="payData.cp" > -->
                <input type="tel" name="phone" placeholder="Teléfono" maxlength="10" v-model="payData.phone" required pattern="[0-9-()+]+">
                <!-- <input type="tel" name="phone" placeholder="Teléfono" maxlength="10" v-model="payData.phone" pattern="[0-9-()+]+"> -->
            </div>
            <div class="form-title">
                <h3>Información de tarjeta de crédito</h3>
                <div class="form-title-cards">
                    <i class="fab fa-cc-amex"></i>
                    <i class="fab fa-cc-mastercard"></i>
                    <i class="fab fa-cc-visa"></i>
                </div>
            </div>
            <div class="form-2c">
                <input data-conekta="card[name]" type="text" name="name" placeholder="Nombre del tarjetahabiente" v-model="payData.name" required>
                <!-- <input data-conekta="card[name]" type="text" name="name" placeholder="Nombre del tarjetahabiente" v-model="payData.name"> -->
                <input data-conekta="card[number]" type="tel" name="card" maxlength="16" placeholder="Número de tarjeta de crédito" v-model="payData.number" required>
                <!-- <input data-conekta="card[number]" type="tel" name="card" maxlength="16" placeholder="Número de tarjeta de crédito" v-model="payData.number"> -->
            </div>
            <div class="form-4c">
                <input data-conekta="card[exp_month]" type="tel" maxlength="2" placeholder="Mes (MM)" v-model="payData.exp_month" required>
                <!-- <input data-conekta="card[exp_month]" type="tel" maxlength="2" placeholder="Mes (MM)" v-model="payData.exp_month"> -->
                <input data-conekta="card[exp_year]" type="tel" maxlength="2" placeholder="Año (YY)" v-model="payData.exp_year" required>
                <!-- <input data-conekta="card[exp_year]" type="tel" maxlength="2" placeholder="Año (YY)" v-model="payData.exp_year"> -->
                <div class="campo">
                    <i id="campo_eye" class="fas fa-eye-slash" @click="hiddenShowCvc()"></i>
                    <input id="cvc_field" data-conekta="card[cvc]" type="password" maxlength="4" placeholder="CVC" v-model="payData.cvc" required>
                    <!-- <input id="cvc_field" data-conekta="card[cvc]" type="password" maxlength="4" placeholder="CVC" v-model="payData.cvc"> -->
                    <i id="campo_question" class="fas fa-question-circle" @mouseover="infoOn(infoCvc)" @mouseleave="infoOff(infoCvc)" @click="info(infoCvc)"></i>
                    <div id="info-cvc" hidden>
                        <img src="../assets/img/cvc_info.jpg" draggable="false">
                    </div>
                </div>
                <div class="campo">
                    <select id="msi_select" disabled v-if="payData.amount < 300">
                        <option hidden selected value="s/MSI">MSI</option>
                    </select>
                    <select id="msi_select" v-if="payData.amount >= 300 && payData.amount < 600" @change="changeMsi()">
                        <option hidden selected value="s/MSI">MSI</option>
                        <option v-for="msiItem3 in msiItems3" :key="msiItem3" :value="msiItem3">{{msiItem3}}</option>
                    </select>
                    <select id="msi_select" v-if="payData.amount >= 600 && payData.amount < 900" @change="changeMsi()">
                        <option hidden selected value="s/MSI">MSI</option>
                        <option v-for="msiItem6 in msiItems6" :key="msiItem6" :value="msiItem6">{{msiItem6}}</option>
                    </select>
                    <select id="msi_select" v-if="payData.amount >= 900 && payData.amount < 1200" @change="changeMsi()">
                        <option hidden selected value="s/MSI">MSI</option>
                        <option v-for="msiItem9 in msiItems9" :key="msiItem9" :value="msiItem9">{{msiItem9}}</option>
                    </select>
                    <select id="msi_select" v-if="payData.amount >= 1200 && payData.amount < 1800" @change="changeMsi()">
                        <option hidden selected value="s/MSI">MSI</option>
                        <option v-for="msiItem12 in msiItems12" :key="msiItem12" :value="msiItem12">{{msiItem12}}</option>
                    </select>
                    <select id="msi_select" v-if="payData.amount >= 1800" @change="changeMsi()">
                        <option hidden selected value="s/MSI">MSI</option>
                        <option v-for="msiItem18 in msiItems18" :key="msiItem18" :value="msiItem18">{{msiItem18}}</option>
                    </select>
                    <i id="campo_msi_question" class="fas fa-question-circle" @mouseover="infoOn(infoMsi)" @mouseleave="infoOff(infoMsi)" @click="info(infoMsi)"></i>
                    <div id="info-msi" hidden>
                        <p>Opcional, Monto minimo $300, 18 MSI sólo con banamex,<br>s/MSI para 1 sola exhibición</p>
                    </div>
                </div>
            </div>
            <div class="form-buttons">
                <div></div>
                <input type="submit" value="Proceder al pago">
                <input type="button" value="Reestablecer" @click="clear()">
                <div></div>
            </div>
        </form>
        <!-- Test alert -->
        <!-- <button style="position: absolute; z-index: 3" @click="testAlert()">test alert</button>
        <input style="position: absolute; z-index: 3" type="text" v-model="alert"> -->
        <div v-show="alertShowCont" id="alert">
            <div v-if="alert.length == 0 " class="load">
                <div class="load1"></div>
                <div class="load2"></div>
            </div>
            <div id="alert-cont">
                <i id="alert-icon"></i>
                <p id="alert-global"><b>{{alert}}</b></p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: "Pago",
    created(){
      window.Conekta.setPublicKey("key_bgNwFSBnLw4sAFhUbe8EsXw");// public key PROD
      //window.Conekta.setPublicKey("key_M8PD7fnJfzw9qQ8s7WMmSEQ");// public key DEV
    },
    data(){
        return{
            payData: {
                amount: '',
                paymentConcept : '',
                firstName: '',
                lastName: '',
                email: '',
                address: '',
                city: '',
                country: '',
                province: '',
                cp: '',
                phone: '',
                name: '',
                number: '',
                cvc: '',
                exp_month: '',
                exp_year: '',
                conektaTokenId: '',
                msi: 's/MSI'
            },
            msiItems3: ['s/MSI', 3],
            msiItems6: ['s/MSI', 3, 6],
            msiItems9: ['s/MSI', 3, 6, 9],
            msiItems12: ['s/MSI', 3, 6, 9 ,12],
            msiItems18: ['s/MSI', 3, 6, 9 ,12, 18],
            countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia & Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre & Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts & Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', `Timor L'Este`, 'Togo', 'Tonga', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks & Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'],
            infoCvc: "cvc",
            infoMsi: "msi",
            alertShowCont: false,
            alert: "",
        }
    },
    methods: {
        conektaSuccessResponseHandler(token){
            this.payData.conektaTokenId = token.id;
            this.payData.exp_month = null;
            this.payData.exp_year = null;
            this.payData.cvc = null;
            console.log(this.payData);
            this.alertShowCont = true;
            //axios.post('http://localhost/apiApolo25/pay.php', this.payData)
            axios.post('https://pago.apolo25.com/apiApolo25/pay.php', this.payData)
                .then(data => {
                    if(data.data == "1"){
                        this.alertShow(data.data, 4000);
                        console.log(data.data);
                        this.clear();
                    }else{
                        this.alertShow(data.data, 3000);
                    }
                })
                .catch(err => {
                    this.alertShow(err, 2000);
                    //console.log(err);
                });
        },
        conektaErrorResponseHandler(response){
            this.alertShowCont = true;
            this.alertShow(response.message_to_purchaser, 2000);
        },
        sendForm(){
            const tokenParams = {
                card: {
                    "name": this.payData["name"],
                    "number": this.payData["number"],
                    "cvc": this.payData["cvc"],
                    "exp_month": this.payData["exp_month"],
                    "exp_year": this.payData["exp_year"],
                    "conektaTokenId": this.payData["conektaTokenId"],
                }
            }
            window.Conekta.Token.create(tokenParams, this.conektaSuccessResponseHandler, this.conektaErrorResponseHandler);
        },
        changeCountry(){
            this.payData.countries = document.getElementById("country_select").value;
        },
        changeMsi(){
            this.payData.msi = document.getElementById("msi_select").value;
        },
        hiddenShowCvc(){
            const cvcElement = document.getElementById("cvc_field");
            const eyeElement = document.getElementById("campo_eye");
            cvcElement.getAttribute("type") == "password" ? cvcElement.setAttribute("type", "tel") : cvcElement.setAttribute("type", "password");
            eyeElement.getAttribute("class") == "fas fa-eye-slash" ? eyeElement.setAttribute("class", "fas fa-eye") : eyeElement.setAttribute("class", "fas fa-eye-slash");
        },
        info(e){
            if(screen.width <= 400){
                document.getElementById(`info-${e}`).removeAttribute("hidden");
                setTimeout(() => {
                    document.getElementById(`info-${e}`).setAttribute("hidden", "");
                }, 3000);
            }
        },
        infoOn(e){
            if(screen.width > 400) document.getElementById(`info-${e}`).removeAttribute("hidden");
        },
        infoOff(e){
            if(screen.width > 400) document.getElementById(`info-${e}`).setAttribute("hidden", "");
        },
        clear(){
            this.payData["amount"] = "";
            this.payData["paymentConcept"] = "";
            this.payData["firstName"] = "";
            this.payData["lastName"] = "";
            this.payData["email"] = "";
            this.payData["email"] = "";
            this.payData["address"] = "";
            this.payData["city"] = "";
            this.payData["country"] = "";
            this.payData["province"] = "";
            this.payData["cp"] = "";
            this.payData["phone"] = "";
            this.payData["name"] = "";
            this.payData["number"] = "";
            this.payData["cvc"] = "";
            this.payData["exp_month"] = "";
            this.payData["exp_year"] = "";
            this.payData["conektaTokenId"] = "";
            this.payData["msi"] = 's/MSI';

            const option_country = document.createElement('option');
            option_country.setAttribute('hidden','true');
            option_country.setAttribute('selected','true');
            option_country.innerText = 'País';
            document.getElementById('country_select').appendChild(option_country);

            const option_msi = document.createElement('option');
            option_msi.setAttribute('hidden','true');
            option_msi.setAttribute('selected','true');
            option_msi.innerText = 'MSI';
            document.getElementById('msi_select').appendChild(option_msi);
        },
        alertShow(response, time){
            const alertIcon = document.getElementById("alert-icon");

            if(response == "1"){
                alertIcon.setAttribute("class", "far fa-check-circle");
                this.alert = "Pago exitoso"
                setTimeout(() => {
                    this.alertShowCont = false;
                    alertIcon.removeAttribute("class");
                    this.alert = "";
                }, time);
            }
            else{
                alertIcon.setAttribute("class", "fas fa-exclamation-triangle");
                this.alert = response;
                setTimeout(() => {
                    this.alertShowCont = false;
                    alertIcon.removeAttribute("class");
                    this.alert = "";
                }, time);
            }
        }

        /* Test alert */
        /*,testAlert(){
            this.alertShowCont ? this.alertShowCont = false : this.alertShowCont = true;
        }*/
    }
}
</script>

<style>
    #terminal_de_pago{
        background-color: #FFF;
        position: relative;
        display: grid;
        margin: 3vw 5% 0% 30%;
        border-radius: 20px;
        box-shadow: 0px 3px 15px -3px #1f26875e;
    }
    form{
        /* background-color: #FFF; */
        font-family: 'Mulish', sans-serif;
        padding: 3% 5%;
    }
    input{
        width: 94%;
        border-radius: 5px;
        background-color: #e3e0ca;
        color: #1d1d1b;
        border: none;
        padding: 1.5vh 0 1.5vh 5%;
        margin: 1.5vh 0;
    }
    input::placeholder{
        color: #1d1d1b;
        opacity: 1;
    }
    select{
        padding: 1.5vh 0 1.5vh 5%;
        margin: 1.5vh 0;
        width: 100%;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 1px 5px 0px #1f26875e;
        background-color: #fff;
        color: #1d1d1b;
    }
    input[type="submit"]{
        padding: 1.5vh 0 1.5vh;
        cursor: pointer;
        background-color: #FC4D21;
        color: #fff;
        font-size: 1vw;
    }
    input[type="button"]{
        padding: 1.5vh 0 1.5vh;
        cursor: pointer;
        background-color: #f8d2b9;
        color: #FC4D21;
        border: #FC4D21 solid 2px;
        font-size: 1vw;
    }
    .form-title{
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }
    .form-title p{
        font-size: 2.5vw;
        color: #1d1d1b;
        margin: 0;
    }
    .form-title h2{
        font-size: 1.5vw;
        color: #1d1d1b;
        margin: 0;
    }
    .form-title h3{
        font-size: 1vw;
        color: #1d1d1b;
        margin: 1.5vh 0 0;
    }
    .form-title-cards{
        display: flex;
        width: 12%;
        justify-content: space-between;
    }
    .form-title-cards i{
        font-size: 1.5vw;
        color: #1d1d1b;
    }
    hr{
        border: solid 1px #f8d2b9;
        background: #f8d2b9;
    }
    .form-2c-3c{
        display: grid;
        grid-template-columns: 28% 68%;
        grid-template-rows: 100%;
        justify-content: space-between;
    }
    .form-2c-3c div{
        position: relative;        
    }
    input[name="monto"]{
        padding-left: 12%;
        width: 87%;
    }
    #amount_dollar{
        position: absolute;
        top: 37%;
        left: 5%;
        color: #1d1d1b;
    }
    .form-3c{
        display: grid;
        grid-template-columns: 30.5% 30.5% 30.5%;
        justify-content: space-between;
    }
    .form-2c{
        display: grid;
        grid-template-columns: 48% 48%;
        justify-content: space-between;
    }
    .form-4c{
        display: grid;
        grid-template-columns: 21.5% 21.5% 21.5% 21.5%;
        justify-content: space-between;
    }
    .campo{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .campo i{
        cursor: pointer;
        color: #1d1d1b;
        margin-right: 3%;
    }
    #campo_question{
        position: absolute;
        top: auto;
        bottom: auto;
        right: 5%;
        margin: auto;
        color: #38b4d4;
    }
    #info-cvc{
        position: absolute;
        bottom: 100%;
        width: 175%;
        border-radius: 10px;
    }
    #info-msi{
        position: absolute;
        top: 100%;
        right: -10%;
        width: 240%;
        background-color: rgba(160, 160, 160, 0.8);
        border-radius: 10px;
    }
    #info-msi p{
        color: #fff;
        text-align: center;
    }
    #info-cvc img{
        width: 100%;
        border-radius: 10px;
    }
    #campo_msi_question{
        color: #1d1d1b;
        margin-left: 5%;
    }
    .form-buttons{
        display: grid;
        grid-template-columns: 20% 25% 25% 20%;
        justify-content: space-between;
    }
    #alert {
        background-color: rgba(245, 245, 245, 0.8);
        position: absolute;
        top: 0%;
        bottom: 0%;
        right: 0%;
        left: 0%;
        margin: auto;
        z-index: 2;
        border-radius: 20px;
        width: 100%;
        height: 100%;
    }
    #alert-cont{
        background-color: #fff;
        position: absolute;
        top: 0%;
        bottom: 0%;
        right: 0%;
        left: 0%;
        margin: auto;
        z-index: 3;
        width: 35vw;
        height: fit-content;
        min-height: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 3px 15px -3px #1f26875e;
        border-radius: 20px;
    }
    .load {
        position: relative;
        top: 0%;
        bottom: 0%;
        left: 0%;
        right: 0%;
        margin: auto;
        z-index: 4;
        width: 100%;
        height: 100%;
    }
    .load1{
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: 0%;
        right: 0%;
        margin: auto;
        width: 7rem;
        height: 7rem;
        border-radius: 50%;
        border: solid 10px transparent;
        border-top: solid 10px #FC4D21;
        border-left: solid 10px #FC4D21;
        animation: loader1 1.5s linear infinite;
    }
    .load2{
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: 0%;
        right: 0%;
        margin: auto;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        border: solid 10px transparent;
        border-top: solid 10px #f8d2b9;
        border-left: solid 10px #f8d2b9;
        animation: loader2 1.5s linear infinite;
    }
    #alert p{
        padding: 1.5vh 0 1.5vh 5%;
        margin: 1.5vh 0;
        font-size: 2vw;
        color: #FC4D21;
        font-family: 'Mulish', sans-serif;
    }
    #alert i{
        padding: 1.5vh 0 1.5vh 5%;
        margin: 1.5vh 0;
        font-size: 2.5vw;
        color: #FC4D21;
    }

    @keyframes loader1{
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    @keyframes loader2{
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(-360deg);
        }
    }
    
    @media (max-width: 500px) {
        #terminal_de_pago{
            grid-template-columns: 100%;
            margin: 5%;
            margin-top: 55%;
        }
        #la_imagen{
            top: 0;
            left: 0;
            width: 50vw;
        }
        input,
        select{
            font-size: 3vw;
        }
        input[name="name"],
        input[name="card"]{
            font-size: 2.6vw;
        }
        input[type="submit"],
        input[type="button"]{
            font-size: 4vw;
        }
        .form-title{
            flex-wrap: wrap;
        }
        .form-title p{
            font-size: 7vw;
        }
        .form-title h2{
            font-size: 5vw;
        }
        .form-title h3{
            font-size: 4vw;
        }
        .form-title-cards{
            width: 50%;
        }
        .form-title-cards i{
            font-size: 10vw;
        }
        .form-2c-3c{
            grid-template-columns: 30% 64%;
        }
        input[name="monto"] {
            padding-left: 25%;
            width: 82%;
        }
        .form-3c, .form-2c, .form-4c{
            grid-template-columns: repeat(2, 48%);
        }
        input[name="email"],
        input[name="address"],
        input[name="city"] {
            grid-column: 1/3;
        }
        .form-buttons{
            grid-template-columns: 0% 48% 48% 0%;
        }
        input[type="submit"],
        input[type="button"]{
            width: 100%;
        }
        #alert-cont{
            width: 80vw;
        }
        #alert p{
            font-size: 7vw;
        }
        #alert i{
            font-size: 10vw;
        }
    }
</style>